import http from '@/api/common'

export default {
  authUser(credentials, callback, error) {
    http.auth(credentials, callback, error)
  },
  getUserInfo(username) {
    return http.get(`user/getUserByName?username=${username}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/auth.js